/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { type ReactNode } from 'react';

import { jsx } from '@compiled/react';

import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

export type TPopoverSurfaceProps = {
	children: ReactNode;
};

const styles = cssMap({
	root: {
		backgroundColor: token('elevation.surface.overlay'),
		// Pairs the text colour with the overlay background, so the surface keeps its
		// contrast wherever it is rendered.
		color: token('color.text'),
		borderRadius: token('radius.large'),
		boxShadow: token('elevation.shadow.overlay'),
		overflow: 'auto',
	},
});

/**
 * Optional styled wrapper for popover content.
 *
 * Adds default visual styling (background, border-radius, box-shadow)
 * using design tokens.
 *
 * Presentational primitive - `children`-only by design. This component
 * intentionally exposes no `style`, `className`, `xcss`, `id`, or `ref`
 * props. If you need any of those, render your own wrapper element inside
 * `Popover` instead. `PopoverSurface` is the no-config "give me the default
 * ADS overlay look" surface, nothing more.
 */
export function PopoverSurface({ children }: TPopoverSurfaceProps): ReactNode {
	return <div css={styles.root}>{children}</div>;
}
